import React from 'react'
import WhoHero from '../../Components/who/WhoHero'
import { Briefcase, Share2, Monitor, Factory, RotateCw } from 'lucide-react';
import UserFirstExperienceSection from '../../Components/servicex/UserFirstExperienceSection'
import ServiceX360ViewSection from '../../Components/servicex/ServiceX360ViewSection'
import ServiceXOfferingsSection from '../../Components/servicex/ServiceXOfferingsSection'
import IndustriesServiceExperienceSection from '../../Components/servicex/IndustriesServiceExperienceSection'
import WhatSetsApartSection from '../../Components/servicex/WhatSetsApartSection'
import OtherExpertLedSolutionsSection from '../../Components/servicex/OtherExpertLedSolutionsSection'
import CaseStudySection from '../../Components/servicex/CaseStudySection'
import FAQSection from '../../Components/servicex/FAQSection'
import WhatToExpectSection from '../../Components/servicex/WhatToExpectSection';
import WeCanAlsoHelpWithSection from '../../Components/servicex/WeCanAlsoHelpWithSection';

const serviceItems = [
    {
        id: 1,
        title: "Elevate service delivery with trusted, consistent data",
        description: "Streamline communication, onboarding, and lifecycle management across vendor networks with connected, transparent digital workflows.",
        image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 2,
        title: "Unleash agility and innovation across the enterprise",
        description: "Deploy automated workflows and scalable data foundations to cut cycle times and accelerate organizational growth.",
        image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 3,
        title: "Enhance decision-making with a prescriptive data model",
        description: "Gain unified visibility and leverage actionable insights through standardized data structures to drive continuous business improvements.",
        image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1000&q=80"
    }
];


const solutionsData = [
    {
        id: 1,
        title: "ServiceX",
        desc: "Deliver connected service experiences across IT, workplace, customer operations, and field teams to improve engagement and performance.",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: 2,
        title: "Intelligent Operations",
        desc: "Modernize enterprise operations with connected workflows, real-time visibility, and automation that improves service performance and operational efficiency.",
        image: "/assets/mumbai/item9.png",
        link: "#"
    },
    {
        id: 3,
        title: "Risk and Security",
        desc: "Strengthen governance, compliance, and resilience through integrated risk workflows that reduce exposure and protect critical business services.",
        image: "/assets/mumbai/item1.png",
        link: "#"
    }
];

const offeringsData = [
    {
        id: 1,
        title: "Consulting",
        desc: "We evaluate your IT service ecosystem, pinpointing gaps in configuration data, broken asset relationships, and fragmented information. By reviewing service models, data governance, and quality practices, we craft a structured CSDM approach that delivers clarity, accountability, and end-to-end visibility across your enterprise services.",
        products: []
    },
    {
        id: 2,
        title: "Implementation",
        desc: "We implement ServiceNow CSDM to centralize service and configuration data, standardize relationships between assets, applications, and services, and integrate seamlessly across ITSM and ITOM. This reduces errors, strengthens governance, and accelerates automation.",
        products: []
    },
    {
        id: 3,
        title: "Support and Maintenance",
        desc: "We monitor data quality, refine service models, and optimize workflows to keep configuration data accurate, actionable, and aligned with business goals, enabling smarter decisions and faster Now Platform value.",
        products: []
    },
    {
        id: 4,
        title: "Resources and Pod",
        desc: "Our experts partner with your IT, operations, and business teams to improve data quality, governance, and collaboration, turning configuration data into measurable business impact and optimized service management.",
        products: []
    }
];


const industryTabs = [
    {
        id: "it-operations",
        label: "IT Operations",
        title: "IT Operations",
        desc: "Leverage Predictive Intelligence to proactively identify and resolve issues, minimizing downtime and enhancing service reliability.[cite: 27]",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: "customer-service",
        label: "Customer Service",
        title: "Customer Service",
        desc: "Deploy Virtual Agents to provide instant, 24/7 support, reducing case volumes and improving customer satisfaction.[cite: 27]",
        image: "/assets/mumbai/item1.png",
        link: "#"
    },
    {
        id: "human-resources",
        label: "Human Resources",
        title: "Human Resources",
        desc: "Automate onboarding, manage employee inquiries, and personalize HR services, fostering a more engaged workforce.[cite: 27]",
        image: "/assets/mumbai/item5.png",
        link: "#"
    },
    {
        id: "security-operations",
        label: "Security Operations",
        title: "Security Operations",
        desc: "Utilize AI-driven analytics to detect threats, automate incident responses, and maintain robust security postures.[cite: 27]",
        image: "/assets/mumbai/item9.png",
        link: "#"
    },
    {
        id: "finance-procurement",
        label: "Finance and Procurement",
        title: "Finance and Procurement",
        desc: "Streamline invoice processing and procurement workflows through intelligent automation, enhancing accuracy and efficiency.[cite: 27]",
        image: "/assets/mumbai/item2.png",
        link: "#"
    },
    {
        id: "facilities-management",
        label: "Facilities Management",
        title: "Facilities Management",
        desc: "Optimize space utilization and maintenance schedules with AI-powered insights, ensuring operational excellence.[cite: 27]",
        image: "/assets/mumbai/item7.png",
        link: "#"
    }
];

const apartData = [
    {
        id: 1,
        title: "Extensive Experience",
        desc: "Extensive experience designing, implementing, and optimizing CSDM for enterprises"
    },
    {
        id: 2,
        title: "Seamless Integration",
        desc: "Seamlessly integrate CSDM with ITSM, ITOM, ITAM, and other modules"
    },
    {
        id: 3,
        title: "Best-Practice Frameworks",
        desc: "Best-practice frameworks accelerating service delivery and ROI"
    },
    {
        id: 4,
        title: "Proven Track Record",
        desc: "Proven track record of enterprise deployments driving measurable business outcomes"
    }
];

const caseStudies = [
    {
        id: 'virgin',
        name: 'Virgin Mobile',
        logoText: 'Virgin Mobile',
        image: '/assets/mumbai/img1.png',
        title: 'Unified IT and Customer Service Operations on ServiceNow for Virgin Mobile UAE',
        desc: 'Reduced service friction, improved operational efficiency, and enhanced customer satisfaction within six months of go-live.',
        link: '#',
        badges: [
            'Deflection in 730 cases',
            'Reduction in agent attrition',
            'Reduction in unfavorable experiences'
        ]
    },
    {
        id: 'ansr',
        name: 'ANSR',
        logoText: 'ANSR',
        image: '/assets/mumbai/img2.png',
        title: 'AI-Enabled Service Operations for ANSR',
        desc: 'Leveraged automation and self-service to reduce manual effort and enhance service delivery across functions.',
        link: '#',
        badges: [
            'Faster Resolution',
            'Improved Employee Satisfaction',
            'Reduced Operational Costs'
        ]
    },
    {
        id: 'entain',
        name: 'Entain',
        logoText: 'Entain',
        image: '/assets/mumbai/img3.png',
        title: 'Enterprise HR Policy Governance Transformation for Entain',
        desc: 'Aligned policy lifecycle with knowledge visibility to ensure consistency, control, and better access management.',
        link: '#',
        badges: [
            'Automated the entire policy lifecycle',
            'Aligned HR policies with governance',
            'Controlled Knowledge Base visibility'
        ]
    },
    {
        id: 'maruti',
        name: 'MARUTI SUZUKI',
        logoText: 'Maruti Suzuki',
        image: '/assets/mumbai/img4.png',
        title: 'Streamlined Dealer Finance & Audit Operations for Maruti Suzuki',
        desc: 'Enabled faster processing, real-time financial insights, and improved compliance across dealer networks.',
        link: '#',
        badges: [
            'Reduced Turnaround Time (TAT)',
            'Enhanced Transparency & Audit Readiness',
            'Instant financial exposure insights'
        ]
    }
];

const faqData = [
    {
        id: 1,
        question: "Is CSDM a separate product we need to buy?",
        answer: "No. CSDM is a framework and best-practice data model for your CMDB; it comes included with your ServiceNow instance."
    },
    {
        id: 2,
        question: "How does CSDM support AI and GenAI (Now Assist) integration?",
        answer: "CSDM provides clean, structured, and context-rich service mapping across enterprise assets. This structured foundation enables Now Assist and AI models to accurately understand dependencies, route incidents intelligently, and generate precise operational insights."
    },
    {
        id: 3,
        question: "We already use ITSM and ITOM. Do we still need CSDM?",
        answer: "Yes. CSDM acts as the common language and blueprint connecting ITSM and ITOM. Without CSDM, configuration items and services often remain siloed, leading to inaccurate impact analysis and governance challenges."
    },
    {
        id: 4,
        question: 'What are the "Four Domains" of CSDM?',
        answer: "The four core domains of CSDM are Foundation (shared reference data), Design (business applications and architecture), Manage Technical Services (underpinning infrastructure and technical services), and Sell/Deliver (business services and customer offerings)."
    },
    {
        id: 5,
        question: "Can Aelum help migrate to the latest CSDM version (e.g., 4.0 or 5.0)?",
        answer: "Yes, Aelum offers end-to-end migration roadmaps, legacy CMDB health assessments, and guided transition frameworks to align your platform seamlessly with the latest CSDM standards."
    }
];


const expectItems = [
    "Structured Domains",
    "Service-Centric Modeling",
    "Dynamic CI Groups",
    "Standardized Life Cycle",
    "Service Builder",
    "AI/GenAI Integration"
];

function CSDM() {
    return (
        <div>
            <WhoHero
                title="ServiceNow CSDM Implementation Partner"
                text="ServiceNow CSDM Implementation Partner"
                imgData="/assets/glodesk/bg2.png"
            />
            {/* <UserFirstExperienceSection title="Your productivity with ServiceNow AI" description="The AI era is advancing faster than we ever imagined, quickly becoming the driving force behind modern enterprises—fuelling progress with every insight and breakthrough. The real advantage lies in how efficiently and effectively an organization delivers value to both its customers and employees. To make impossible possible, businesses need a trusted partner like Aelum Consulting to shape and implement AI solutions that carve out a unique, transformative path. With the power of ServiceNow AI, we connect and automate workflows across your entire enterprise, unifying AI, data, and processes on a single, intelligent platform. This seamless integration not only streamlines operations but also empowers your teams to focus on what truly matters—driving growth and delivering exceptional value." /> */}
            <ServiceX360ViewSection title="Realize Complete Now Platform Value Through CSDM Alignment" description="Effective IT service management requires clarity, consistency, and connected data. Aelum enables a centralized view of your IT infrastructure, services, and business assets with ServiceNow CSDM. We help you standardize asset mapping across modules like Incident, Problem, Change, and Configuration Management, creating a common language that breaks down silos and fosters collaboration between IT and business stakeholders. By structuring data across the entire service lifecycle, from planning and design to operation and maintenance, you gain actionable insights, streamline workflows, and accelerate decision-making." serviceItems={serviceItems} />
            <ServiceXOfferingsSection offeringsData={offeringsData} title="Our ServiceNow CSDM Services" description="Gain Full Visibility and Governance Across Enterprise Services and Assets with ServiceNow CSDM" />
            <WhatToExpectSection title="What to expect from ServiceNow CSDM" description="" expectItems={expectItems} />
            <WeCanAlsoHelpWithSection />
            {/* <IndustriesServiceExperienceSection title="ServiceNow AI for Every Corner of Your Business" industryTabs={industryTabs} /> */}
            <WhatSetsApartSection title="Why Mobikode for ServiceNow CSDM?" description="Our deep expertise across experience transformation, workflow design, and enterprise service delivery helps organizations realize faster adoption and measurable outcomes with ServiceX." apartData={apartData} />
            {/* <OtherExpertLedSolutionsSection title="Other Expert-led Solutions" description="   Accelerate enterprise transformation with integrated, intelligent workflows engineered to drive operational resilience and business value." solutionsData={solutionsData} /> */}
            <CaseStudySection title="Real-World Case Studies" description=" See how we help global enterprises drive measurable operational outcomes and unified service delivery." caseStudies={caseStudies} />
            <FAQSection faqData={faqData} />
        </div>
    )
}

export default CSDM
